<template>
  <el-form
    ref="form"
    label-position="top"
    :model="form"
    :rules="validateRules"
    @validate="onValidateChange"
  >
    <el-form-item
      label="이름"
      prop="name"
    >
      <el-input
        v-model="form.name"
        data-test="input-member-name"
        placeholder="반드시 실명을 입력해주세요"
        @change="onChangeForm"
      />
    </el-form-item>

    <el-form-item
      label="생년월일"
      prop="birth"
    >
      <el-input
        v-model="form.birth"
        data-test="input-member-birth"
        placeholder="숫자 8자리로 입력해주세요"
        :max="8"
        @change="onChangeForm"
      />
    </el-form-item>

    <el-form-item
      label="성별"
      prop="gender"
    >
      <div class="register__radio-group">
        <el-radio
          v-model="form.gender"
          label="1"
          border
        >
          남성
        </el-radio>
        <el-radio
          v-model="form.gender"
          label="2"
          border
        >
          여성
        </el-radio>
      </div>
    </el-form-item>

    <el-form-item
      label="휴대전화번호"
      prop="phone_number"
    >
      <el-input
        v-model="form.phone_number"
        data-test="input-member-phone"
        placeholder="- 을 제외하고 번호만 입력해주세요"
        @change="onChangeForm"
      />
    </el-form-item>

    <el-form-item prop="email">
      <div slot="label">
        피플박스 앱 이메일 계정
        <popover>
          피플박스 앱을 이용할 수 있는 이메일 계정입니다.<br>
          실제 사용 중인 이메일이 아니면 비밀번호 분실 시<br>
          찾을 수 없습니다.
        </popover>
      </div>

      <el-input
        v-model="form.email"
        data-test="input-member-email"
        placeholder="유효한 이메일을 입력해주세요"
        @change="onChangeForm"
      />
    </el-form-item>

    <el-form-item>
      <div slot="label">
        피플박스 앱 최초 비밀번호
        <popover>
          피플박스 앱 최초 로그인 시 필요한 임시 비밀번호<br>
          입니다. 반드시 로그인 후 새 비밀번호 재설정을<br>
          권장해주시길 바랍니다.
        </popover>
      </div>

      <el-input
        :value="centerAccount.code.toLowerCase()"
        placeholder="유효한 이메일을 입력해주세요"
        disabled
      />
    </el-form-item>
  </el-form>
</template>

<script>
import {
  validateEmailOnSignup,
  validateName,
  validatePhoneNum,
  validateBirthday
} from '../../utils/form-validate-rules';
import { mapGetters } from 'vuex';
import Popover from '../../components/popover';

export default {
  name: 'MemberRegisterForm',
  components: {
    Popover
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      form: {
        name: '',
        birth: '',
        gender: '1',
        phone_number: '',
        email: ''
      },
      isFormValid: {
        name: false,
        phone_number: false,
        email: false
      },
      validateRules: {
        email: [{ validator: validateEmailOnSignup, trigger: 'blur' }],
        name: [{ validator: validateName, trigger: 'blur' }],
        birth: [{ validator: validateBirthday, trigger: 'blur' }],
        phone_number: [{ validator: validatePhoneNum, trigger: 'blur' }]
      }
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(originObject) {
        if (originObject === undefined) {
          return;
        }

        Object.keys(originObject).forEach(key => {
          this.$set(this.form, key, originObject[key]);
        });

        this.$emit('input', originObject);
      }
    }
  },
  computed: {
    ...mapGetters({
      centerAccount: 'getCenterAccount'
    }),
    isValidated() {
      return Object.values(this.isFormValid).every(i => i);
    }
  },
  methods: {
    onChangeForm() {
      this.$emit('input', this.form);
    },
    validate() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate(isValidated => {
          resolve(isValidated);
        });
      });
    },
    resetFields() {
      this.$refs.form.resetFields();
    },
    onValidateChange($event, isValidated) {
      this.isFormValid[$event] = isValidated;
      this.$emit('validate', this.isValidated);
    }
  }
};
</script>

<style lang="scss">
.register__radio-group {
  display: flex;

  label {
    flex: auto;
  }
}
</style>
